<template lang="pug">
    .search
        v-text-field.search__input(
            v-bind="$attrs"
            v-on="$listeners"
            autocomplete="off"
            color="black"
        )
        v-btn.search__btn(@click="$emit('click:search')" :disabled="!searchEnabled" icon)
            v-icon mdi-magnify
</template>

<script>
export default {
    props: {
        searchEnabled: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped>
.search {
    display: flex;
    align-items: center;
}
</style>
